class SmartRecommender extends HTMLElement {
  constructor() {
    super();
    this.callAttempt = 0;
    this.campaignId = parseInt(this.getAttribute("data-campaign-code-desktop"));

    this.init();
  }

  init() {
    this.callAttempt++;
    if (typeof window.recommendationData === "undefined") {
      if (this.callAttempt < 6) {
        setTimeout(this.init.bind(this), 1000);
      } else {
        // console.log("Smart Recommender: Não foi possível carregar os dados do produto");
        this.enableGlide(false);
      }
      return;
    }
    this.handleData();
  }

  getWindowWidth() {
    return parseInt(document.getElementsByTagName("html")[0].clientWidth);
  }

  async handleData() {
    if (this.getWindowWidth() < 750 && this.getAttribute("data-campaign-code-mobile") != "") {
      this.campaignId = parseInt(this.getAttribute("data-campaign-code-mobile"));
    }

    const { products } =
      window.recommendationData[this.campaignId] ??
      window.recommendationData[Object.keys(window.recommendationData)[0]];

    if (products.length > 0) {
      const listUrlProducts = products.map((product) => product.url);
      const HTMLproducts = await this.handleProduct(listUrlProducts);

      this.renderHTML(HTMLproducts);
    } else {
      this.enableGlide(false);
    }
  }

  async handleProduct(listUrlProducts) {
    const listFetch = listUrlProducts.map((url) =>
      fetch(`${url}${url.includes("?") ? "&" : "?"}view=${this.dataset.template}`).then((response) => response.text()),
    );

    let listFetchProcessed = await Promise.all(listFetch)
      .then((HTMLProduct) => {
        return HTMLProduct;
      })
      .catch((error) => {
        console.error(error);
      });
    return listFetchProcessed;
  }

  renderHTML(HTMLproducts) {
    for (let i = 0; i < HTMLproducts.length; i++) {
      const product = new DOMParser().parseFromString(HTMLproducts[i], "text/html");
      if (HTMLproducts[i].indexOf("product-card-snippet") > 0) {
        const card = product.querySelector(`.${this.dataset.classCardProduct}`);
        const listItems = this.querySelector(`.${this.dataset.classContainer}`);

        listItems.append(card);
      }
    }

    if (this.dataset.glide === "true") {
      this.enableGlide();
    }
    this.classList.add("active");
  }

  enableGlide(useinsiderCollectionLoaded = true) {
    this.querySelector(`.loading-smart-recommender`).style.display = "none";

    const elementGlide = useinsiderCollectionLoaded ? "main_collection" : "reserve_collection";
    const glideRecommender = this.querySelector(`.${elementGlide}`);
    glideRecommender.classList.add("active");
    glideRecommender.glideEnable();

    if (this.dataset.glideControl === "true" && useinsiderCollectionLoaded) {
      glideRecommender.glideSetControlls();
    }

    glideRecommender.init();
  }
}

customElements.define("smart-recommender", SmartRecommender);
